import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NAV_ITEMS } from '../../data/homeData';
import IconImg from './IconImg';

export default function SportsNav() {
  const navigate = useNavigate();
  const go = (e, href) => { e.preventDefault(); if (href && href !== '#') navigate(href); };
  return (
    <div className="new-middle-menus">
      <ul>
        {NAV_ITEMS.map((it) => {
          const cls = [it.active ? 'nmm-active' : '', it.hot ? 'hightlight-menu' : '', it.tag ? 'new-tag-menus' : '']
            .filter(Boolean).join(' ');
          return (
            <li className="nav-item" key={it.id}>
              <a id={`nav-${it.id}`} href={it.href} className={cls} onClick={(e) => go(e, it.href)}>
                <IconImg src={it.icon} />
                {it.tag ? <b>{it.label}</b> : ` ${it.label} `}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
